/**
 * Il tipo di movimento, con una tinta pastello per famiglia (TODO.md).
 *
 * ## Perché non `<Badge tone=…>`
 *
 * I toni del `Badge` sono **semantici**: `warning` vuol dire «deve ancora
 * accadere», `negative` «è andato male». Un versamento non è un avvertimento e
 * una vendita non è un guasto. Riusare quei toni per il colore avrebbe fatto
 * leggere a chi conosce l'applicazione un significato che qui non c'è — quindi
 * la tavolozza è propria, e usa gli stessi token *soft* così da restare
 * coerente con il resto e con il tema scuro.
 *
 * ## Le famiglie
 *
 * Il colore segue la **direzione del denaro**, non il nome del movimento:
 * entra in titoli (verde), esce da titoli (rosso), rende (azzurro), entra in
 * cassa (giallo), esce dalla cassa (arancio), costa (grigio). Un piano di
 * accumulo è un acquisto; una ricompensa di staking è un rendimento.
 */

import { TX_TYPE_LABELS, labelFor } from '@/lib/format';
import { familyOf } from './tx-type-family';
import './portfolios.css';

export function TxTypeBadge({ txType }: { txType: string }) {
  return (
    <span className={`badge tx-badge tx-badge--${familyOf(txType)}`}>{labelFor(TX_TYPE_LABELS, txType)}</span>
  );
}
